

// Cache keys for user data
const USER_CACHE_KEY = 'supabase_user_data';
const USER_CACHE_TIMESTAMP_KEY = 'supabase_user_timestamp';

// Helper to check if cached user data is still valid (10 minutes)
const isCachedUserValid = (): boolean => {
  const timestamp = localStorage.getItem(USER_CACHE_TIMESTAMP_KEY);
  if (!timestamp) return false;
  
  const cacheTime = new Date(timestamp).getTime();
  const now = new Date().getTime();
  const tenMinutes = 10 * 60 * 1000; // 10 minutes in milliseconds
  
  return (now - cacheTime) < tenMinutes;
};

// Get cached user data
export const getCachedUser = () => {
  const cached = localStorage.getItem(USER_CACHE_KEY);
  if (!cached || !isCachedUserValid()) return null;
  try {
    return JSON.parse(cached);
  } catch {
    return null;
  }
};

// Set cached user data
export const setCachedUser = (user: any) => {
  localStorage.setItem(USER_CACHE_KEY, JSON.stringify(user));
  localStorage.setItem(USER_CACHE_TIMESTAMP_KEY, new Date().toISOString());
};

// Clear cached user data
export const clearCachedUser = () => {
  localStorage.removeItem(USER_CACHE_KEY);
  localStorage.removeItem(USER_CACHE_TIMESTAMP_KEY);
};

// Get user with caching
export const getCachedUserData = async () => {
  // Check cache first
  const cachedUser = getCachedUser();
  if (cachedUser) {
    console.log('Using cached user data');
    return cachedUser;
  }

  // Fetch from Supabase if not cached
  console.log('Fetching user data from Supabase');
  const { supabase } = await import('@/integrations/supabase/client');
  const { data: { user } } = await supabase.auth.getUser();
  
  // Cache the result only if user exists
  if (user) {
    setCachedUser(user);
  }
  
  return user;
};
